import { SurveyTranslations } from "./en";

const no: SurveyTranslations = {
  locale: "no",

  Header: {
    logout: "Logg ut",
  },

  LoginDialog: {
    title: "Logg inn",
    email: "E-post",
    password: "Passord",
    login: "Logg inn",
    loginError: "Kunne ikke logge inn med angitt e-post/passord.",
    sessionExpired: "Din innlogging har utløpt. Vennligst logg inn igjen.",
    loggedInAs: "Logget inn som {{loggedInUser}}",
    switchUser: "Bytt bruker",
  },

  HomeView: {
    title: "Adaptive Survey",
    create: "Lag ny undersøkelse",
  },

  CreateView: {
    title: "Ny undersøkelse",
  },

  EditView: {
    loading: "Laster undersøkelse...",
    loadError: "Kunne ikke laste undersøkelse.",
  },

  ResultsView: {
    loading: "Laster undersøkelse...",
    loadError: "Kunne ikke laste undersøkelse.",
  },

  Results: {
    backToAllSurveys: "Tilbake til alle undersøkelser",
    responses: ["{{n}} besvarelse", "{{n}} besvarelser"],
    resultsInfo: "Trykk på stolper for å filtrere utvalget.",
    download: "Last ned data",
    print: "Skriv ut rapport",
    printWarning:
      "Vennligst skriv ut denne rapporten ved å trykke på Skriv ut rapport-knappen.",
    includeInPrint: "Inkluder datatabell i utskrift",
    multiselect: "(flervalg)",
    yes: "Ja",
    no: "Nei",
    noAnswer: "Ikke besvart",
    created: "Sendt inn",
    clearFilter: "Fjern filter",
    clearAllFilters: "Fjern alle filter",
    filters: "Data er filtrert",
    count: "Antall",
    openImage: "Vis bilde",
    editValue: "Rediger {{label}}",
    admin: "(admin)",
    save: "Lagre",
    cancel: "Avbryt",
  },

  CollectionView: {
    loading: "Laster undersøkelse...",
    loadError: "Kunne ikke laste undersøkelse.",
    surveyNotActive: "Denne undersøkelsen er ikke tilgjengelig",
    pleasePublishFirst:
      "Undersøkelsen har blitt avpublisert og er ikke lenger tilgjengelig.",
    goBack: "Gå tilbake",
    saving: "Sender inn dine svar",
    saveErrorTitle: "En feil oppstod!",
    saveErrorText:
      "Din besvarelse ble ikke lagret.\n\nVennligst prøv igjen eller ta kontakt med den som publiserte undersøkelsen for å få hjelp.",
  },

  Editor: {
    save: "Lagre",
    saved: "Lagret",
    unsaved: "Ingen endringer",
    backToAllSurveys: "Tilbake til alle undersøkelser",
    goToSurvey: "Gå til undersøkelse",
    publish: "Publiser",
    unpublish: "Avpubliser",
    preview: "Forhåndsvis",
    livePreview: "Live forhåndsvisning",
    mobilePreview: "Mobil forhåndsvisning",
    desktopPreview: "Desktop forhåndsvisning",
    saving: "Lagrer undersøkelse...",
    saveErrorTitle: "Kunne ikke lagre undersøkelse",
    saveError: "Undersøkelsen inneholder feil. Vennligst endre følgende:",
    unsavedChangesConfirm:
      "Du har endringer som ikke er lagret. Fortsett likevel?",
    unsavedChangesTitle: "Du har ulagrede endringer",
    unsavedChanges: "Vennligst lagre før du fortsetter.",
    metaDataError:
      "Det oppstod et problem under lasting av undersøkelsens metadata. Vennligst prøv igjen.",
    discard: "Forkast endringer",
    invalidWarning: ["{{n}} problem", "{{n}} problemer"],
  },

  Metadata: {
    title: "Innstillinger",
    editMetadata: "Rediger innstillinger",
    info: "Vennligst beskriv undersøkelsen slik at den er gjenkjennelig i administrator-verktøyet. <b>Dette er ikke synlig for undersøkelsens deltagere.</b>",
    createdBy: "Laget av",
    created: "Dato opprettet",
    metaCompletionRedirectInfo:
      "Brukeren blir sendt videre til denne URLen ved innsending av svar istedenfor den vanlige fullføringsskjermen.",
    public: "Offentlig",
    private: "Privat",
    cancel: "Avbryt",
    ok: "Gå til skjemadesigner",
  },

  DesignSchema: {
    title: "Design skjemaet",
    info: "Legg til tittel, tekstfelt, bilder og andre felt som deltageren skal få opp.",
    plainAddGroup: "Legg til gruppe",
    wizardAddGroup: "Legg til side",
    plainAddSection: "Legg til element",
    wizardAddSection: "Legg til element (egen side)",
    plainAddSectionInGroup: "Legg til element i gruppen",
    wizardAddSectionInGroup: "Legg til element på siden",
    addSectionToGetStarted: "Legg til et element for å komme i gang!",
    standardFieldsInfo:
      "<h3>Standardfelter</h3><p>Merk at noen felter blir automatisk opprettet for deg:<ul><li>En unik id per besvarelse</li><li>Når besvarelsen ble sendt inn</li></ul><p>Du trenger ikke legge til dette selv.",
  },

  SectionForm: {
    back: "Tilbake",
    next: "Neste",
    cancel: "Avbryt",
    add: "Legg til",
    save: "Lagre",
    type: "Felttype:",
    edit: "Rediger",
    addSection: "Legg til element",
    editSection: "Rediger felt",
    input: "Velg felttype",
    display: "Velg presentasjonselement",
    geometry: "Velg geometritype",
    advanced: "Avanserte innstillinger",
    advancedSummary: "Feltnavn: {{columnName}} {{admin}}",
    administrative: "Administrativt",
    gdprWarning:
      "<b>Advarsel:</b> Tekstfelt kan benyttes til å sende inn personlig informasjon. Pass på hva slags informasjon du ber om og om gjeldende regelverk (som GDPR) kan inneholde retningslinjer for hvordan data prosesseres og krav til samtykke.",
    emailWarning:
      "<b>Advarsel:</b> E-postadresse er personlig informasjon. Tenk gjennom om det er et behov for å spørre om dette, og ta hensyn til gjeldende regelverk om personvern (som GDPR).",
    booleanRequiredInfo:
      "<b>Advarsel:</b> Hvis du velger påkrevet, så MÅ sjekkboksen krysses av før brukeren får fortsette. Dette er nyttig for samtykke.",
  },

  SectionColumnName: {
    override: "Tilpass",
  },

  Section: {
    section: "Felt",
    edit: "Rediger",
    delete: "Slett",
    confirmDelete: "Trykk en gang til for å bekrefte.",
    type: "Felttype",
    columnName: "Feltnavn",
    required: "Påkrevet",
    administrative: "Administrativt",
    admin: "Admin",
    yes: "Ja",
    no: "Nei",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
  },

  Layout: {
    plain: "Skjema",
    plainDescription:
      "<p>Hele skjemaet blir presentert på én side.</p>" +
      "<p>Bruk grupper til å splitte skjemaet opp i flere logiske deler.</p>",
    wizard: "Veiviser",
    wizardDescription:
      "<p>Hvert element blir presentert på en egen side, med tilbake/fortsett-knapper.</p>" +
      "<p>For å vise flere elementer på en side kan de grupperes sammen.</p>" +
      "<p>Tittelen vil bare vises på første side. Benytt tittelfelt eller tittel i grupper for å legge til tittel på resten av sidene.</p>",
  },

  LayoutRenderer: {
    emptySchema: "Skjemaet er tomt! Legg til minst ett element.",
    submit: "Send inn",
  },

  GroupSet: {
    delete: "Slett gruppe (feltene blir ikke slettet)",
    confirmDelete: "Trykk en gang til for å bekrefte.",
    moveUp: "Flytt gruppe opp",
    moveDown: "Flytt gruppe ned",
  },

  SectionType: {
    undefinedDescription: "Velg en type element for å se beskrivelse.",
    display: "Presentasjon",
    displayDescription:
      "Legg til overskrifter, tekster eller bilder som vises til den som skal fylle ut undersøkelsen.",
    display_heading: "Overskrift",
    display_text: "Tekst",
    display_image: "Bilde",
    input: "Andre felter",
    inputDescription:
      "Legg til felter hvor deltakeren kan fylle inn tekst, velge fra lister, laste opp bilde, osv.",
    text: "Tekst (èn linje)",
    text_area: "Lang tekst",
    email: "E-postadresse",
    url: "Lenke/URL",
    boolean: "Sjekkboks (sann/usann)",
    integer: "Tallverdi (heltall)",
    decimal: "Tallverdi (desimaltall)",
    date: "Dato",
    list: "Liste (ett valg)",
    multiselect_list: "Liste (flervalg)",
    media: "Bilde/\u00addokument\u00adopplasting",
    rating: "Rating",
    geometry: "Geometri",
    geometryDescription:
      "Legg til et kart hvor brukeren kan tegne inn punkt, linje eller flate.",
    geometry_point: "Punkt",
    geometry_line: "Linje",
    geometry_polygon: "Flate",

    foreign_key: "Fremmednøkkel",
    datetime: "Dato/tid",
    uuid: "UUID",
    dictionary: "Oppslag",
    multiselect_dictionary: "Oppslag (flervalg)",
  },

  MediaType: {
    image: "Bilde",
    document: "Dokument",
  },

  RatingSymbol: {
    heart: "Hjerter",
    star: "Stjerner",
    smiley: "Smilefjes",
  },

  Form: {
    metaTitleLabel: "Navn på undersøkelse",
    metaDescriptionLabel: "Beskrivelse",
    metaPublicDataLabel: "Tilgangsnivå på innsamlet data",
    metaCompletionRedirectUrlLabel: "Send til nettside etter utfylling",
    metaLanguageLabel: "Språk på undersøkelsen",
    slugLabel: "Navn til nettadressen til undersøkelsen",
    slugInfo:
      "Dette vil bli benyttet som en del av nettadressen (URL) når brukerne går inn på undersøkelsen. Denne må være unik, og bør ikke endres etter undersøkelsen er publisert. Du kan kun bruke små bokstaver fra a-z, tall, understreker og bindestreker. Mellomrom er ikke tillatt.",
    slugExample:
      "Når undersøkelsen er publisert er den tilgjengelig på: <code>{{url}}</code>",
    layoutLabel: "Utforming",
    titleLabel: "Tittel",
    plainGroupTitleLabel: "Gruppetittel",
    wizardGroupTitleLabel: "Sidetittel",
    columnNameLabel: "Feltnavn (kun til internt bruk)",
    columnNameInfo:
      "Må være små bokstaver, uten mellomrom, kun bokstaver fra a-z, nummer, understreker, og starte med en bokstav. Denne må ikke endres etter noen har besvart undersøkelsen.",
    labelLabel: "Tittel",
    labelInfo:
      "Dette er spørsmålet eller feltbeskrivelsen som forteller brukeren hva de skal fylle inn.",
    helpTextLabel: "Hjelpetekst",
    helpTextInfo:
      "Hvis spørsmålet trenger en lengre forklaring kan du fylle den inn her.",
    requiredLabel: "Påkrevet",
    administrativeLabel: "Administrativt",
    administrativeInfo:
      "Administrative felt blir ikke samlet inn i skjema, men kan fylles ut senere i resultater eller i Adaptive.",
    headingLabel: "Overskrift",
    contentLabel: "Tekst",
    imageLabel: "Bilde",
    acceptLabel: "Opplastingstype",
    minLabel: "Minimum verdi",
    maxLabel: "Maksimum verdi",
    symbolLabel: "Symbol",
    ratingMaxLabel: "Antall valg",
    decimalsLabel: "Maks antall desimaler",
    itemsLabel: "Valg",
    itemsInfo:
      "Legg til valgene som blir presentert til brukeren. Må ikke inneholde komma (,).",
    multiLabel: "Multi-geometri",
    mapSettingsLabel: "Kartinnstillinger",
    basemapLabel: "Velg et bakgrunnskart",
    basemapInfo:
      "Kartlaget må støtte projeksjonen EPSG:3857. Hvis bakgrunnskartet ikke vises i forhåndsvisningen nedenfor kan det ikke brukes.",
    layerSelectTitle: "Velg et kartlag",
    summary: "Nesten ferdig!",
    summaryInfo:
      "Vennligst se igjennom svarene dine. Trykk på send inn-knappen når du er klar.",
    submit: "Send inn",
    add: "Legg til",
    next: "Fortsett",
    prev: "Tilbake",
    optional: "valgfri",
    required: "påkrevet",
    mediaDocument: "Dokument",
    mediaUpload: "Last opp",
    mediaRemove: "Fjern",
    yes: "Ja",
    no: "Nei",
    answered: "Besvart",
    unanswered: "Ikke besvart",
    noSelection: "Ingen valgt",
    defaultGeometryMissingInfo:
      'En av geometrikolonnene må hete "geom". Dette blir standard geometrikolonne for datasettet.',
    polygonInvalid: "En flate må bestå av minst tre punkter.",
    lineInvalid: "En linje må bestå av minst to punkter.",
    formatLabel: "Velg filformat",
  },

  AccessLevelDescriptions: {
    trueDescription:
      "<p>Innsamlede data vil være tilgjengelige uten noen form for innlogging eller passord.</p><p><strong>Advarsel</strong>: Ikke benytt dette når du samler inn sensitiv informasjon!</p>",
    falseDescription:
      "<p>Ingen data er tilgjengelig uten å logge inn.</p><p>Deler av data kan fortsatt publiseres som et tema. Konfigurer dette og mer spesifikk tilgangskontroll i Adaptive Administrator.</p>",
  },

  Paging: {
    noResults: "Ingen resultater",
    results: ["{{n}} resultat", "{{start}} til {{end}} av {{n}} resultater"],
  },

  ConfirmButton: {
    confirmText: "Klikk igjen for å bekrefte",
  },

  PointGeometryPicker: {
    location: "Bruk min posisjon",
    reset: "Fjern punkt",
  },

  LineGeometryPicker: {
    location: "Min posisjon",
    reset: "Start på nytt",
    undo: "Angre siste",
    done: "Ferdig",
  },

  SurveyActionList: {
    publishAction: "Publiser undersøkelsen",
    publish: "Publiser",
    unpublishAction: "Avpubliser undersøkelsen",
    unpublish: "Avpubliser",
    loadingSurveys: "Laster undersøkelser...",
    loadError: "Noe gikk galt",
    retryLoad: "Prøv igjen",
    surveysLoadError: "Kunne ikke laste undersøkelser.",
    publishError: "Kunne ikke publisere/avpublisere undersøkelse: ",
    openSurveyResponseUrl: "Åpne undersøkelsesskjema",
    openSurvey: "Gå til utfylling",
    editSurvey: "Rediger",
    results: "Resultater",
    dateCreated: "Dato opprettet",
    createdBy: "Laget av",
  },

  MapExtentControl: {
    extent: "Sett initiell kartlokasjon",
    optional: "valgfri",
  },

  MapExtentPicker: {
    location: "Gå til min posisjon",
    useExtent: "Sett startområde",
    removeExtent: "Fjern område",
  },

  PolygonGeometryPicker: {
    location: "Min posisjon",
    reset: "Start på nytt",
    undo: "Angre siste",
    done: "Ferdig",
  },

  SurveyCompleteView: {
    title: "Tusen takk!",
    youMayCloseTheWindow:
      'Dine svar til undersøkelsen "{{surveyTitle}}" er registrert.\n\nDu kan nå lukke nettleservinduet/fanen.',
    loadError: "En feil har oppstått",
    loading: "Laster",
    close: "Lukk",
  },

  ValidityDialog: {
    invalid: "Undersøkelsen har noen problemer",
    dataLoss: "Endringer kan føre til tap av data!",
    dataLossWarning:
      "Hvis du fortsetter vil innsendte svar miste data som ble skrevet inn i dette feltet.",
    noSections: "Undersøkelsen har ingen felt brukerne kan besvare.",
    missingField: "Feltet {{name}} kan ikke være tomt.",
    missingDefaultGeom:
      "Undersøkelsen inneholder geometrifelt, men ingen av dem har kolonnenavnet 'geom'. Når man har geometrifelt må hovedgeometrifelt angis. Vennligst gi et av geometrifeltene kolonnenavnet 'geom'.",
    removedColumn: "Felt {{label}} ('{{column}}') har blitt fjernet.",
    duplicateColumn: "Felt {{label}} deler kolonnenavnet '{{column}}'.",
    invalidCast:
      "Felt {{label}} ('{{column}}') var tidligere av type {{from}}, som ikke kan endres til {{to}}. Vennligst endre navnet på '{{column}}', eller endre datatypen.",
    continue: "Fortsett likevel",
    cancel: "Avbryt",
  },

  RichText: {
    linkPrompt: "Legg til lenke",
    save: "Ferdig",
    cancel: "Avbryt",
    hrefLabel: "URL",
    targetLabel: "Åpne i",
    targetReplace: " ",
    targetNew: "Ny fane",
    toggleBold: "Skru av/på fet skrift",
    toggleItalic: "Skru av/på kursiv",
    toggleStrikethrough: "Skru av/på gjennomstrek",
    toggleBulletList: "Skru av/på punktliste",
    toggleOrderedList: "Skru av/på nummerert liste",
    setLink: "Sett lenke",
    unsetLink: "Fjern lenke",
  },

  ThemeModeSwitch: {
    useLightMode: "Bytt til lys modus",
    useDarkMode: "Bytt til mørk modus",
  },
};

export default no;
